var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTeamsActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.605 4)",
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 4.9,
    rx: 4.997,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.065 11.2H4.947C2.218 11.2 0 13.723 0 16.824v3.483c0 .382.274.694.61.694h14.78c.336 0 .61-.312.61-.694v-3.483c0-3.116-2.206-5.622-4.935-5.622z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.146 6.025c.496.017.97.113 1.409.274a4.808 4.808 0 0 0-.902 2.644c-.064 1.816.889 3.436 2.356 4.334a4.45 4.45 0 0 1-3.156 1.142c-2.413-.085-4.304-2.032-4.223-4.35.081-2.318 2.103-4.129 4.516-4.044zM21.112 6.025a4.53 4.53 0 0 0-1.408.274c.538.75.867 1.658.902 2.644.063 1.816-.89 3.436-2.356 4.334a4.45 4.45 0 0 0 3.155 1.142c2.414-.085 4.304-2.032 4.223-4.35-.08-2.318-2.103-4.129-4.516-4.044zM5.605 20.823l-.001 3.176-4.07.001c-.265 0-.485-.216-.527-.498L1 23.405V20.42c0-2.658 1.94-4.818 4.329-4.818l3.392-.002c-1.825.829-3.116 2.857-3.116 5.224zM23.617 20.823v3.176l4.07.001c.265 0 .486-.216.527-.498l.007-.097V20.42c0-2.658-1.94-4.818-4.328-4.818l-3.393-.002c1.825.829 3.117 2.857 3.117 5.224z",
    fill: "#038AB7",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTeamsActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-teams-active.2187dd93065a55386b0b7469b3d51534.svg";